import { atom, useRecoilState, useResetRecoilState } from 'recoil'

const projectsState = atom({
  key: 'ContentProjects',
  default: {
    project: null,
    selectedTab: 'home'
  }
})

export const useContentProjects = () => {
  return useRecoilState(projectsState)
}

export const useResetContentProjects = () => {
  return useResetRecoilState(projectsState)
}